/// REDUX ///
import { useAppDispatch } from "api/hooks/apiHook";
/// ACTIONS ///
import { updateShopMiter } from "api/actions/price_list";
/// TYPES ///
import { IMiter } from "api/types/price_list/edge/miter";
/// COMPONENTS ///
import PriceRow from "../../row";
/// VALUES ///
import { getMaterialHeightDisplay } from "values/material";

interface Props {
  index: number,
  last: boolean,
  miter: IMiter
}

export default function Miter({ index, last, miter }: Props) {
  const dispatch = useAppDispatch();

  return (
    <PriceRow
      index={index}
      last={last}
      original_price={miter?.price ?? 0}
      title={getMaterialHeightDisplay(miter?.material_thickness ?? "")}
      end_text="$/LIN"
      update={price => dispatch(updateShopMiter({ price: price }, miter.id))} />
  )
}
